import { prop, compose } from 'ramda';

const flashMessage = prop('flashMessage');
const messageId = compose(prop('messageId'), flashMessage);
const statusType = compose(prop('statusType'), flashMessage);
const timeoutExpiration = compose(prop('timeoutExpiration'), flashMessage);

export { messageId, statusType, timeoutExpiration };
